"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Bolt = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M11.3336 2.28375C11.6473 2.38119 11.8611 2.67147 11.8611 2.99999V7.80555H15C15.2785 7.80555 15.5341 7.95989 15.6638 8.20639C15.7934 8.45289 15.7758 8.75094 15.618 8.98045L9.50692 17.8693C9.32081 18.1401 8.98017 18.2581 8.66643 18.1607C8.35269 18.0632 8.13889 17.773 8.13889 17.4444V12.6389H5C4.72148 12.6389 4.4659 12.4845 4.33624 12.238C4.20657 11.9915 4.22418 11.6935 4.38197 11.464L10.4931 2.5751C10.6792 2.30438 11.0198 2.1863 11.3336 2.28375ZM6.42577 11.1389H8.88889C9.3031 11.1389 9.63889 11.4747 9.63889 11.8889V15.0297L13.5742 9.30555H11.1111C10.6969 9.30555 10.3611 8.96976 10.3611 8.55555V5.41475L6.42577 11.1389Z", fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd" }) })));
};
Bolt.displayName = 'Bolt';
exports.default = Bolt;
